

//定义terminology类
class Terminology
{
    constructor(english, japanese, chinese)
    {
        this.english = english;
        this.japanese = japanese;
        this.chinese = chinese;
    }
}

class HtmlTagInfo
{
    constructor(tag,description,canOmitEndTag,omitCondition){
        this.tag = tag; // 标签名称
        this.description = description; // 说明
        this.canOmitEndTag = canOmitEndTag; // 是否可以省略结束标签
        this.omitCondition = omitCondition; // 省略结束标签的条件
    }
}


function updateIframe(code, iframe) {
    if (iframe) {
        const doc = iframe.contentDocument || iframe.contentWindow.document;
        doc.open();
        doc.write(code);
        doc.close();
    }
}

function speak(text, lang)
{
    if(!text) return;
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = lang;
    utterance.rate = 0.75;
    utterance.pitch = 0.8;
    speechSynthesis.speak(utterance);

}


export { Terminology, HtmlTagInfo, updateIframe, speak};
